import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _0012c43d = () => interopDefault(import('../pages/Cms.vue' /* webpackChunkName: "pages/Cms" */))
const _374f0252 = () => interopDefault(import('../pages/ContactUs.vue' /* webpackChunkName: "pages/ContactUs" */))
const _6c215e9b = () => interopDefault(import('../pages/Home.vue' /* webpackChunkName: "pages/Home" */))
const _6fb9a69a = () => interopDefault(import('../pages/HydrogenGenerationContactUs.vue' /* webpackChunkName: "pages/HydrogenGenerationContactUs" */))
const _8b029c74 = () => interopDefault(import('../pages/HydrogenGenerationRequestAQuote.vue' /* webpackChunkName: "pages/HydrogenGenerationRequestAQuote" */))
const _8753176a = () => interopDefault(import('../pages/Page.vue' /* webpackChunkName: "pages/Page" */))
const _0cb262be = () => interopDefault(import('../pages/SearchResult.vue' /* webpackChunkName: "" */))
const _1c82c7f7 = () => interopDefault(import('../pages/Success.vue' /* webpackChunkName: "" */))
const _43466b92 = () => interopDefault(import('../pages/__vsf_tests__/contactData.mock.ts' /* webpackChunkName: "pages/__vsf_tests__/contactData.mock" */))
const _71c9a265 = () => interopDefault(import('../pages/__vsf_tests__/hydrogenPageTestUtils.ts' /* webpackChunkName: "pages/__vsf_tests__/hydrogenPageTestUtils" */))
const _6b4387ec = () => interopDefault(import('../pages/__vsf_tests__/SearchResultDataMock.ts' /* webpackChunkName: "pages/__vsf_tests__/SearchResultDataMock" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/Cms",
    component: _0012c43d,
    name: "Cms___default"
  }, {
    path: "/ContactUs",
    component: _374f0252,
    name: "ContactUs___default"
  }, {
    path: "/Home",
    component: _6c215e9b,
    name: "Home___default"
  }, {
    path: "/HydrogenGenerationContactUs",
    component: _6fb9a69a,
    name: "HydrogenGenerationContactUs___default"
  }, {
    path: "/HydrogenGenerationRequestAQuote",
    component: _8b029c74,
    name: "HydrogenGenerationRequestAQuote___default"
  }, {
    path: "/Page",
    component: _8753176a,
    name: "Page___default"
  }, {
    path: "/search-result",
    component: _0cb262be,
    name: "search___default"
  }, {
    path: "/SearchResult",
    component: _0cb262be,
    name: "SearchResult___default"
  }, {
    path: "/success",
    component: _1c82c7f7,
    name: "success___default"
  }, {
    path: "/Success",
    component: _1c82c7f7,
    name: "Success___default"
  }, {
    path: "/hydrogen-generation/contact-us",
    component: _6fb9a69a,
    alias: "/hydrogen-generation-contact-us",
    name: "hydrogen-generation-contact-us___default"
  }, {
    path: "/hydrogen-generation/request-a-quote",
    component: _8b029c74,
    alias: "/hydrogen-generation-request-a-quote",
    name: "hydrogen-generation-request-a-quote___default"
  }, {
    path: "/contact/:subject?",
    component: _374f0252,
    name: "contact___default"
  }, {
    path: "/",
    component: _6c215e9b,
    name: "home___default"
  }, {
    path: "/:slug+",
    component: _8753176a,
    name: "page___default"
  }, {
    path: "/:_vsf_tests__?/contactData.mock",
    component: _43466b92,
    name: "_vsf_tests__-contactData.mock___default"
  }, {
    path: "/:_vsf_tests__?/hydrogenPageTestUtils",
    component: _71c9a265,
    name: "_vsf_tests__-hydrogenPageTestUtils___default"
  }, {
    path: "/:_vsf_tests__?/SearchResultDataMock",
    component: _6b4387ec,
    name: "_vsf_tests__-SearchResultDataMock___default"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
